const testimonials = [
  {
    name: '追更老猫',
    role: '热血漫爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20cheerful%20young%20man%20wearing%20a%20coral%20hoodie%2C%20minimal%20warm%20style%2C%20soft%20cream%20background%2C%20friendly%20expression%2C%20simple%20geometric%20character%20portrait&width=200&height=200&seq=avatar-01&orientation=squarish',
    text: '抢先看真的快，别人家还没影子，喵趣这边已经出汉化了，追更首选没跑了。',
  },
  {
    name: '泡面不加葱',
    role: '恋爱番十级学者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20smiling%20young%20woman%20with%20long%20hair%20and%20amber%20glasses%2C%20minimal%20warm%20style%2C%20soft%20cream%20background%2C%20friendly%20expression%2C%20simple%20geometric%20character%20portrait&width=200&height=200&seq=avatar-02&orientation=squarish',
    text: '最看重未删减高清原版这一点，分镜对白都保留完整，看得就是原汁原味。',
  },
  {
    name: '夜猫子协会会长',
    role: '悬疑推理党',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20young%20man%20with%20short%20dark%20hair%20and%20a%20warm%20smile%2C%20minimal%20warm%20style%2C%20soft%20cream%20background%2C%20simple%20geometric%20character%20portrait&width=200&height=200&seq=avatar-03&orientation=squarish',
    text: '独家翻译质量在线，专有名词处理得很到位，深夜追新作完全不卡壳。',
  },
  {
    name: '今天也很咸鱼',
    role: '搞笑漫死忠',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20playful%20young%20woman%20with%20ponytail%20and%20freckles%2C%20minimal%20warm%20style%2C%20soft%20cream%20background%2C%20happy%20expression%2C%20simple%20geometric%20character%20portrait&width=200&height=200&seq=avatar-04&orientation=squarish',
    text: '同步更新真的说到做到，昨晚首发的番今早就有了，更新速度点个赞。',
  },
];

export default function Reputation() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
      <div className="text-center">
        <p className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
          <i className="ri-heart-3-fill text-accent-600"></i>
          读者口碑
        </p>
        <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">800 万读者的追更之选</h2>
        <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
          一起来听听他们为什么把喵趣漫画网当成每天的追更第一站。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((t) => (
          <figure
            key={t.name}
            className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-200"
          >
            <div className="flex items-center gap-1 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm"></i>
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-background-100 pt-4">
              <img src={t.avatar} alt={`${t.name} 头像`} className="h-10 w-10 rounded-full object-cover" />
              <div>
                <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-600">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}